import { useCallback, useEffect, useState } from 'react';
import { fetchEnquiryDetail } from '../api/enquiries';

export function useEnquiryDetail(reference) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(Boolean(reference));
    const [error, setError] = useState(null);
    const [reloadIndex, setReloadIndex] = useState(0);

    useEffect(() => {
        if (!reference) {
            setData(null);
            setLoading(false);
            setError(null);
            return undefined;
        }

        let cancelled = false;

        setLoading(true);
        setError(null);

        fetchEnquiryDetail(reference)
            .then((result) => { if (!cancelled) setData(result); })
            .catch((err) => { if (!cancelled) setError(err); })
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };

    }, [reloadIndex, reference]);

    const reload = useCallback(() => setReloadIndex((index) => index + 1), []);

    return { data, loading, error, reload };
}
